export enum LoadingDisplayModeEnum {
  TOAST = "toast",
  SCREEN = "screen",
  INLINE = "inline",
  SPINNER = "spinner"
}

export type LoadingDisplayModeValue = `${LoadingDisplayModeEnum}`;